import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
export interface EnvConfigModel {
  apiUrl: string;
  ptkUrl: string;
  isMock?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class EnvConfigService {
  private _envConfig: EnvConfigModel = {
    apiUrl: '',
    ptkUrl: '',
  };
  loaded = false;
  constructor(private injector: Injector) {}

  async init(evnFileUrls: string) {
    const http = this.injector.get(HttpClient);
    this._envConfig = await firstValueFrom(
      http.get<EnvConfigModel>(evnFileUrls)
    );
    this.loaded = true;
    return;
  }

  get envConfig() {
    return this._envConfig;
  }
}
